module.exports = "<ng-progress [color]=\"'blue'\" [showSpinner]=\"false\"  [ease]=\"'linear'\" [minimum]=\"0.15\" [maximum]=\"1\"></ng-progress>\n<!-- header banner -->\n<martmax-header></martmax-header>\n\n<!-- sticky -->\n<martmax-sticky></martmax-sticky>\n\n<!-- mega-menu -->\n<mega-menu></mega-menu>\n\n<router-outlet></router-outlet>\n\n<!-- footer -->\n<martmax-footer></martmax-footer>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main